import Type from "@/model/types/Type";

const type = {
    NONE: 10,
    BASIC: 30, /*Padrão*/
    FULL: 50,
}

const list = [
    {
        value: type.NONE,
        text: "Nenhum gráfico",
    },
    {
        value: type.BASIC,
        text: "Somente de anomalias",
    },
    {
        value: type.FULL,
        text: "Completo",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}